export enum FavouriteColor {
	BLUE = 'BLUE',
	RED = 'RED',
	GRAY = 'GRAY',
	ORANGE = 'ORANGE',
	PINK = 'PINK',
	YELLOW = 'YELLOW'
}
